module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }), _vm._v("This is a work of fiction. All of the characters, organizations, and events"), _c('br'), _vm._v("portrayed in this novel are either products of the author’s imagination or"), _c('br'), _vm._v("are used fictitiously.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DELILAH")]), _vm._v(". Copyright © 2009 by India Edghill. All rights reserved."), _c('br'), _vm._v("Printed in the United States of America. For information, address"), _c('br'), _vm._v("St. Martin’s Press,"), _c('br'), _vm._v("175 Fifth Avenue, New York, N.Y. 10010.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_c('a', {
    attrs: {
      "href": "http://www.stmartins.com",
      "target": "_blank"
    }
  }, [_vm._v("www.stmartins.com")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_vm._v("Map by Jackie Aher")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Edghill, India.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("Delilah / India Edghill.—1st ed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("        p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("ISBN 978-0-312-33891-6")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para2"
  }, [_vm._v("  1. Delilah (Biblical figure)—Fiction. 2. Samson (Biblical judge)—Fiction. 3. Bible. O.T.—History of Biblical events—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("PS3555.D474D45 2009")]), _vm._v(" "), _c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "85%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "indent-para1"
  }, [_vm._v("813’.54—dc22")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "para1a"
  }, [_vm._v("2009024138")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_vm._v("First Edition: December 2009")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para-s"
  }, [_vm._v("10    9    8    7    6    5    4    3    2    1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-322dcd54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 69
// module chunks = 0